import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ResultContext, ResultStates } from '../ResultContext';
import ResultsHeader from '../../components/ResultsHeader/ResultsHeader';
import { Forms } from '../../forms';
import { useIntl } from 'react-intl';

const Header = ({ DefaultComponent, ErrorComponent, ...rest }) => {
  const intl = useIntl();
  const { screeningGuid, state, variant } = useContext(ResultContext);

  const renderDefault = () => (
    <ResultsHeader title={intl.formatMessage({ id: 'screenings.results.header.thank-you' })} />
  );

  const ComponentStates = {
    [ResultStates.Default]: DefaultComponent ?? renderDefault,
    [ResultStates.Error]: ErrorComponent ?? renderDefault,
  };

  if (state !== ResultStates.Found) {
    const Component = ComponentStates[state];
    if (!Component) return <></>;
    return <Component />;
  }

  const FormComponent = Forms[screeningGuid][variant];

  return <FormComponent {...rest} />;
};

Header.propTypes = {
  DefaultComponent: PropTypes.element,
  ErrorComponent: PropTypes.element,
};

export default Header;
